import { MaskService } from '@shared/services/mask.service';
import { catchError, map, of } from 'rxjs';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';
import { SelectPesquisavelService } from '@shared/components/select-pesquisavel/select-pesquisavel.service';
import {
  PesquisaCodigoTributacaoModalComponent,
  PesquisaCodigoTributacaoModalData,
  PesquisaCodigoTributacaoModalResult,
} from '@shared/components/pesquisa-codigo-tributacao-modal/pesquisa-codigo-tributacao-modal.component';
import { Component, Input, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ModeloDocumento } from '../../../../../../../shared/services/models/dfe/modelo-documento.model';
import { AlertService, AlertType } from '../../../../../../../shared/services/alert.service';
import { ModeloDocumentoService } from '../../../../../../../shared/services/apis/dfe/modelo-documento.service';
import { AuthService } from '../../../../../../../shared/services/apis/usuario/auth.service';
import { Empresa } from '../../../../../../../shared/services/models/usuario/empresa.model';

@Component({
  selector: 'app-filtro-painel-contador',
  standalone: true,
  imports: [
    NgxMaskDirective,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  providers: [provideNgxMask()],
  templateUrl: './filtro-painel-contador.component.html',
})
export class FiltroPainelContadorComponent implements OnInit {
  readonly masks = MaskService.getMasks();
  public form: FormGroup;
  public listaEmpresas: Empresa[] = [];
  public listaModeloDocumento: ModeloDocumento[] = [];
  public isLoadingLookup = true;

  constructor(
    private selectPesquisavelService: SelectPesquisavelService,
    private dialog: MatDialog,

    private fb: FormBuilder,
    private authService: AuthService,
    private modeloDocumentoService: ModeloDocumentoService,
    private alertService: AlertService
  ) {
    this.form = this.fb.group({
      tiposNota: [[]],
      listCnpj: [[]],
      pesquisar: [''],
      cfop: [''],
      isCacnelada: [null],
      serie: [''],
    });
  }

  ngOnInit(): void {
    this.carregarLookups();
    if (this.isEdicao) this.form.disable();
  }

  @Input() isEdicao: boolean = false;

  @Input()
  set jsonFiltros(json: string) {
    if (json) {
      try {
        const valores = JSON.parse(json);
        this.form.patchValue(valores);
      } catch (e) {
        console.error('Erro parse filtros contador', e);
      }
    }
  }

  public getValues(): any {
    return this.form.getRawValue();
  }

  private carregarLookups(): void {
    this.isLoadingLookup = true;

    this.modeloDocumentoService.listar().subscribe({
      next: res => {
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.listaModeloDocumento = res.modelos || [];
        this.carregarEmpresas(); // Carrega empresas após lookup
        this.isLoadingLookup = false;
      },
      error: err => {
        this.isLoadingLookup = false;
        console.error(err);
      },
    });
  }

  private carregarEmpresas(): void {
    // Mesma lógica de carregamento de empresas baseada no AuthService
    const userInfo = this.authService.getUserInfos();
    const empresaAtual = userInfo.listaEmpresa.find(x => x.idEmpresa == userInfo.idEmpresa);

    if (!userInfo.listaEmpresasDoGrupo?.length) {
      if (empresaAtual) this.listaEmpresas.push(empresaAtual);
    } else {
      if (!userInfo.empresaPrincipalGrupo || userInfo.listaEmpresasDoGrupo.length === 1) {
        this.listaEmpresas = userInfo.listaEmpresasDoGrupo?.filter(x => x.idEmpresa == userInfo.idEmpresa);
      } else {
        this.listaEmpresas = userInfo.listaEmpresasDoGrupo;
      }
    }
  }

  pesquisarCfop(): void {
      if (this.form.get('cfop')?.disabled) return;
      const ref = this.dialog.open(PesquisaCodigoTributacaoModalComponent, {
          width: '700px',
          maxWidth: '95vw',
          maxHeight: '85vh',
          panelClass: 'pesquisa-codigo-tributacao-dialog',
          data: {
              titulo: 'Pesquisar CFOP',
              buscarFn: (pesquisa: string) => this.selectPesquisavelService
                  .getSelectValues<{ codigo?: string; descricao: string }>(environment.urlApiMotorFiscal + 'Lookup/cfop', pesquisa)
                  .pipe(
                      map(list => ({
                          isError: false,
                          itens: list.map(i => ({ codigo: String(i.codigo ?? ''), descricao: i.descricao })),
                      })),
                      catchError(() => of({ isError: true, itens: [] })),
                  ),
              permitirManual: false,
              registrosIniciais: 20,
              valorInicial: this.form.get('cfop')?.value ?? undefined,
          } satisfies PesquisaCodigoTributacaoModalData,
      });
      ref.afterClosed().subscribe((result: PesquisaCodigoTributacaoModalResult | null) => {
          if (!result?.selecionado) return;
          this.form.get('cfop')?.setValue(result.selecionado.codigo.replace(/\D/g, ''));
          this.form.get('cfop')?.markAsDirty();
      });
  }
}
